const $e527ffacf02e5bf7$var$NSFW_THRESHOLD = 0.05; // 1% threshold
// Store both canvas context and images array globally
let $e527ffacf02e5bf7$var$canvasContext = null;
let $e527ffacf02e5bf7$var$images = [];
const $e527ffacf02e5bf7$var$MAX_IMAGES = 20;
let $e527ffacf02e5bf7$var$currentImage = null;
let $e527ffacf02e5bf7$var$blackPause = 0;
let $e527ffacf02e5bf7$var$ticksTillNextImage = 0;
let $e527ffacf02e5bf7$var$isClear = false;
const $e527ffacf02e5bf7$var$States = {
    NORMAL: 'normal',
    EXPLORE: 'explore'
};
let $e527ffacf02e5bf7$var$currentState = $e527ffacf02e5bf7$var$States.NORMAL;
let $e527ffacf02e5bf7$var$allowNSFW = false; // Default to safe mode
let $e527ffacf02e5bf7$var$isMouseDown = false;
let $e527ffacf02e5bf7$var$lastDisplayedImage = null;
document.addEventListener('DOMContentLoaded', ()=>{
    $e527ffacf02e5bf7$var$canvasContext = $e527ffacf02e5bf7$var$initializeCanvas();
    $e527ffacf02e5bf7$var$startAnimationLoop();
});
function $e527ffacf02e5bf7$export$e68aa12be6c5ebb8({ allowNSFW: nsfw = false } = {}) {
    $e527ffacf02e5bf7$var$allowNSFW = nsfw;
}
function $e527ffacf02e5bf7$export$7bc0801d8428ec28(imageObject) {
    // Content filtering
    // const classification = imageObject.classification || [];
    // if (classification.length == 0) {
    //     return null;
    // }
    // const isNSFW = classification.length == 0 || classification.some(c => 
    //     (c.className === 'Porn' || c.className === 'Hentai') && 
    //     c.probability > NSFW_THRESHOLD
    // );
    // if (!allowNSFW && isNSFW) {
    //     // console.warn('NSFW content filtered');
    //     return null;
    // }
    // if (images.length >= MAX_IMAGES) {
    //     images.shift(); // Remove oldest image
    // }
    // Create and load image
    const img = new Image();
    img.src = imageObject.fullsize;
    img.onload = ()=>{
        // Calculate scaled dimensions (max 300px)
        const scale = Math.min(300 / img.width, 300 / img.height, 1);
        const width = img.width * scale;
        const height = img.height * scale;
        // Store image with its dimensions and random position
        $e527ffacf02e5bf7$var$images.push({
            element: img,
            width: width,
            height: height,
            x: Math.floor(Math.random() * ($e527ffacf02e5bf7$var$canvasContext.viewportWidth - width)),
            y: Math.floor(Math.random() * ($e527ffacf02e5bf7$var$canvasContext.viewportHeight - height))
        });
    };
    return img;
}
const $e527ffacf02e5bf7$var$drawFrame = ()=>{
    const { ctx: ctx, viewportWidth: viewportWidth, viewportHeight: viewportHeight } = $e527ffacf02e5bf7$var$canvasContext;
    // Skip all drawing logic if mouse is down
    if (!$e527ffacf02e5bf7$var$isMouseDown) {
        // Randomly clear image array
        if (Math.random() < 0.0015 && $e527ffacf02e5bf7$var$images.length > 7) {
            $e527ffacf02e5bf7$var$images = [];
            $e527ffacf02e5bf7$var$ticksTillNextImage = 20 + Math.floor(Math.random() * 30);
        }
        // Handle tick counter
        if ($e527ffacf02e5bf7$var$ticksTillNextImage > 0) $e527ffacf02e5bf7$var$ticksTillNextImage--;
        // Main drawing logic
        if ($e527ffacf02e5bf7$var$blackPause === 0 && $e527ffacf02e5bf7$var$images.length > 0) {
            $e527ffacf02e5bf7$var$isClear = false;
            if ($e527ffacf02e5bf7$var$currentState === $e527ffacf02e5bf7$var$States.EXPLORE) {
                const size = Math.random() * 0.6;
                const sourceWidth = $e527ffacf02e5bf7$var$currentImage.element.width * size;
                const sourceHeight = $e527ffacf02e5bf7$var$currentImage.element.height * size;
                const x = sourceWidth * Math.random();
                const y = sourceHeight * Math.random();
                ctx.drawImage($e527ffacf02e5bf7$var$currentImage.element, x, y, sourceWidth, sourceHeight, 0, 0, viewportWidth, viewportHeight);
                if (Math.random() < 0.2) $e527ffacf02e5bf7$var$currentState = $e527ffacf02e5bf7$var$States.NORMAL;
                $e527ffacf02e5bf7$var$blackPause = 1;
            }
            if ($e527ffacf02e5bf7$var$currentState === $e527ffacf02e5bf7$var$States.NORMAL) {
                if (!$e527ffacf02e5bf7$var$currentImage || Math.random() < 0.7) $e527ffacf02e5bf7$var$currentImage = $e527ffacf02e5bf7$var$images[Math.floor(Math.random() * $e527ffacf02e5bf7$var$images.length)];
                ctx.drawImage($e527ffacf02e5bf7$var$currentImage.element, 0, 0, viewportWidth, viewportHeight);
                if (Math.random() < 0.15) $e527ffacf02e5bf7$var$currentState = $e527ffacf02e5bf7$var$States.EXPLORE;
                // Set black pause duration based on number of images
                if ($e527ffacf02e5bf7$var$images.length < 5) $e527ffacf02e5bf7$var$blackPause = Math.floor(Math.random() * ($e527ffacf02e5bf7$var$MAX_IMAGES - $e527ffacf02e5bf7$var$images.length) * 3);
                else if ($e527ffacf02e5bf7$var$images.length < 10) $e527ffacf02e5bf7$var$blackPause = Math.floor(Math.random() * 4);
                else $e527ffacf02e5bf7$var$blackPause = Math.floor(Math.random() * 2);
                $e527ffacf02e5bf7$var$isClear = false;
            }
            // Store the last successfully drawn image
            if ($e527ffacf02e5bf7$var$currentImage && !$e527ffacf02e5bf7$var$isClear) $e527ffacf02e5bf7$var$lastDisplayedImage = $e527ffacf02e5bf7$var$currentImage;
        } else {
            if (!$e527ffacf02e5bf7$var$isClear && Math.random() < 0.8) {
                ctx.fillStyle = '#000000';
                ctx.fillRect(0, 0, viewportWidth, viewportHeight);
                $e527ffacf02e5bf7$var$isClear = true;
            }
            if ($e527ffacf02e5bf7$var$blackPause > 0) $e527ffacf02e5bf7$var$blackPause--;
        }
    } else if ($e527ffacf02e5bf7$var$lastDisplayedImage) // When mouse is down, keep showing the last displayed image
    ctx.drawImage($e527ffacf02e5bf7$var$lastDisplayedImage.element, 0, 0, viewportWidth, viewportHeight);
    requestAnimationFrame($e527ffacf02e5bf7$var$drawFrame);
};
// Replace existing startAnimationLoop with:
const $e527ffacf02e5bf7$var$startAnimationLoop = ()=>{
    const { ctx: ctx } = $e527ffacf02e5bf7$var$canvasContext;
    ctx.imageSmoothingEnabled = false;
    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, $e527ffacf02e5bf7$var$canvasContext.viewportWidth, $e527ffacf02e5bf7$var$canvasContext.viewportHeight);
    requestAnimationFrame($e527ffacf02e5bf7$var$drawFrame);
};
const $e527ffacf02e5bf7$var$initializeCanvas = ()=>{
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    // Move viewport sizing logic to separate function for reuse
    const updateCanvasSize = ()=>{
        const dpr = window.devicePixelRatio || 1;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        canvas.width = viewportWidth * dpr;
        canvas.height = viewportHeight * dpr;
        canvas.style.width = `${viewportWidth}px`;
        canvas.style.height = `${viewportHeight}px`;
        ctx.scale(dpr, dpr);
        return {
            viewportWidth: viewportWidth,
            viewportHeight: viewportHeight
        };
    };
    // Initial canvas setup
    const viewport = updateCanvasSize();
    // Add resize listener
    window.addEventListener('resize', ()=>{
        const newViewport = updateCanvasSize();
        $e527ffacf02e5bf7$var$canvasContext.viewportWidth = newViewport.viewportWidth;
        $e527ffacf02e5bf7$var$canvasContext.viewportHeight = newViewport.viewportHeight;
    });
    // Combined mouse and touch event handlers
    const handleStart = ()=>$e527ffacf02e5bf7$var$isMouseDown = true;
    const handleEnd = ()=>$e527ffacf02e5bf7$var$isMouseDown = false;
    // Mouse events
    canvas.addEventListener('mousedown', handleStart);
    canvas.addEventListener('mouseup', handleEnd);
    canvas.addEventListener('mouseleave', handleEnd);
    // Touch events
    canvas.addEventListener('touchstart', (e)=>{
        e.preventDefault(); // Prevent scrolling/zooming
        handleStart();
    });
    canvas.addEventListener('touchend', handleEnd);
    canvas.addEventListener('touchcancel', handleEnd);
    document.body.appendChild(canvas);
    return {
        canvas: canvas,
        ctx: ctx,
        viewportWidth: viewport.viewportWidth,
        viewportHeight: viewport.viewportHeight
    };
};


const $35da740d59af89ba$var$getWebSocketUrl = ()=>{
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = window.location.hostname;
    const port = window.location.hostname === 'localhost' ? ':3001' : '';
    const path = window.location.hostname === 'localhost' ? '' : '/ws';
    return `${protocol}//${host}${port}${path}`;
};
function $35da740d59af89ba$export$72947bc920927fd0({ allowNSFW: allowNSFW = false } = {}) {
    const url = $35da740d59af89ba$var$getWebSocketUrl();
    const ws = new WebSocket(url);
    (0, $e527ffacf02e5bf7$export$e68aa12be6c5ebb8)({
        allowNSFW: allowNSFW
    });
    ws.onmessage = (event)=>{
        const message = JSON.parse(event.data);
        const images = message.embed.images;
        images.forEach((image)=>{
            (0, $e527ffacf02e5bf7$export$7bc0801d8428ec28)(image, allowNSFW);
        });
    };
    ws.onclose = ()=>{
        console.log('WebSocket closed. Reconnecting...');
        // Try to reconnect after 1 second
        setTimeout($35da740d59af89ba$export$72947bc920927fd0, 1000);
        console.log('Attempting to reconnect...');
    };
    ws.onerror = (error)=>{
        console.error('WebSocket error:', error);
        ws.close();
    };
    ws.onopen = ()=>{
        console.log('WebSocket connected');
    };
}
const $35da740d59af89ba$var$initializeWithModal = ()=>{
    const modal = document.getElementById('modal');
    const warning1 = document.querySelector('.warning-1');
    const warning2 = document.querySelector('.warning-2');
    // First warning button
    document.querySelector('.warning-1 button').addEventListener('click', ()=>{
        warning1.style.display = 'none';
        warning2.style.display = 'block';
    });
    // SFW button
    // document.querySelector('.warning-2 button.sfw').addEventListener('click', () => {
    //     modal.style.display = 'none';
    //     connectWebSocket({ allowNSFW: false });
    // });
    // NSFW button
    document.querySelector('.warning-2 button.nsfw').addEventListener('click', ()=>{
        modal.style.display = 'none';
        $35da740d59af89ba$export$72947bc920927fd0({
            allowNSFW: true
        });
    });
};
// Replace the previous connectWebSocket() call with:
document.addEventListener('DOMContentLoaded', $35da740d59af89ba$var$initializeWithModal);


//# sourceMappingURL=client.04a08735.js.map
